import * as types from '../../constants/ActionTypes'
import { fetchData } from '../Buy'

export const getTransazioniIban = (dispatch, getState) => {
  const idAuto = getState().product.id_auto
  const uri = `${
    window.brumbrum.url_api
  }/transazioni/p/v2/conti?id_auto=${idAuto}&v=${new Date().getTime()}`
  return dispatch(
    fetchData(types.GET_TRANSAZIONI_IBAN)({
      callback: types.GET_TRANSAZIONI_IBAN,
      errorMessage: types.GET_TRANSAZIONI_IBAN,
      method: 'GET',
      uri,
    })
  )
}

export const transazioniCreateSepaIntent = (dispatch, getState) => {
  const idOrdine = getState().ordine.id_ordine
  const { email } = getState().customer
  const uri = `${window.brumbrum.url_api}/transazioni/t/v2/transazione`
  return dispatch(
    fetchData(types.POST_TRANSAZIONI_CREATE_SEPA_INTENT)({
      callback: types.POST_TRANSAZIONI_CREATE_SEPA_INTENT,
      errorMessage: types.POST_TRANSAZIONI_CREATE_SEPA_INTENT,
      method: 'POST',
      body: { id_ordine: idOrdine, email },
      uri,
    })
  )
}
